__turbopack_context__.v({
  "lowerPaper": "TS3dwW_lowerPaper",
});
